// extracted by mini-css-extract-plugin
export default {"container":"banner-faq_container__wyhuP","perguntas-faq":"banner-faq_perguntas-faq__s4Dyo"};